module.exports = __webpack_public_path__ + "h5/img/funv-title2.213682be.png";